'use strict';
(() => {
  if(customElements.get('idolnest-navigation'))return;
  class IdolnestNavigation extends HTMLElement {
    connectedCallback(){
      if(this.events)return;
      this.dialog=this.querySelector('[data-in-nav-dialog]');
      if(!this.dialog)return;
      this.events=new AbortController();
      const options={signal:this.events.signal};
      this.addEventListener('click',event=>{
        if(event.target.closest('[data-in-nav-close]')){this.close();return;}
        if(event.target.closest('[data-in-nav-search]')){this.pendingSearch=true;this.close();return;}
        const link=event.target.closest('a[href]');
        if(link&&!event.ctrlKey&&!event.metaKey&&!event.shiftKey&&!event.altKey)this.close();
      },options);
      this.dialog.addEventListener('click',event=>{
        if(event.target!==this.dialog)return;
        const rect=this.dialog.getBoundingClientRect();
        if(event.clientX<rect.left||event.clientX>rect.right||event.clientY<rect.top||event.clientY>rect.bottom)this.close();
      },options);
      this.dialog.addEventListener('close',()=>this.afterClose(),options);
    }
    disconnectedCallback(){
      this.pendingSearch=false;
      if(this.dialog?.open){if(window.IdolnestDrawerMotion)window.IdolnestDrawerMotion.dispose(this.dialog);else this.dialog.close();this.restoreScroll();}
      this.events?.abort();
      this.events=null;
      this.setExpanded(false);
    }
    setExpanded(open){document.querySelector('.site-header [data-action="menu"]')?.setAttribute('aria-expanded',String(open));}
    close(){if(window.IdolnestDrawerMotion)return window.IdolnestDrawerMotion.close(this.dialog);this.dialog.close();}
    toggle(){if(this.dialog?.open&&!window.IdolnestDrawerMotion?.isClosing(this.dialog))this.close();else this.open();}
    open(){
      if(!this.dialog||(this.dialog.open&&!window.IdolnestDrawerMotion?.isClosing(this.dialog)))return;
      if(!this.dialog.open){this.opener=document.activeElement;this.previousOverflow=document.body.style.overflow;this.syncArtists();}else this.pendingSearch=false;
      if(window.IdolnestDrawerMotion)window.IdolnestDrawerMotion.open(this.dialog,'left');else this.dialog.showModal();
      document.body.style.overflow='hidden';
      this.setExpanded(true);
    }
    restoreScroll(){
      if(this.previousOverflow!==undefined){if(!document.querySelector('dialog[open]'))document.body.style.overflow=this.previousOverflow;this.previousOverflow=undefined;}
    }
    afterClose(){
      if(this.dialog.open)return;
      this.restoreScroll();
      this.setExpanded(false);
      if(this.pendingSearch){
        this.pendingSearch=false;
        const search=document.querySelector('idolnest-search');
        if(typeof search?.open==='function')search.open();else location.href=this.dataset.searchUrl;
      }else if(this.opener?.isConnected&&!document.querySelector('dialog[open]'))this.opener.focus({preventScroll:true});
    }
    syncArtists(){
      const holder=this.querySelector('[data-in-nav-artists]');
      if(!holder)return;
      const cards=Array.from(document.querySelectorAll('.artist-card[data-in-shared-artist]'));
      const names=new Set(),links=[];
      for(const card of cards){
        const name=card.querySelector('.in-artist-name')?.textContent.trim();
        if(!name||names.has(name.toLocaleLowerCase()))continue;
        let url;try{url=new URL(card.getAttribute('href'),location.origin);}catch{continue;}
        if(url.origin!==location.origin||!['http:','https:'].includes(url.protocol))continue;
        const link=document.createElement('a');
        link.className='in-nav-artist-link';
        link.href=url.pathname+url.search+url.hash;
        link.textContent=name;
        link.dataset.artistCategory=card.dataset.inArtistCategory||'other';
        names.add(name.toLocaleLowerCase());links.push(link);
        if(links.length===30)break;
      }
      if(links.length)holder.replaceChildren(...links);
    }
  }
  customElements.define('idolnest-navigation',IdolnestNavigation);
})();
